import { render, staticRenderFns } from "./InformacionAdicionalSolicitud.vue?vue&type=template&id=664f496a&scoped=true"
import script from "./InformacionAdicionalSolicitud.vue?vue&type=script&lang=js"
export * from "./InformacionAdicionalSolicitud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664f496a",
  null
  
)

export default component.exports